import { Controller } from "@hotwired/stimulus"

// Card styling for answered vs pending — kept in sync with the server-rendered
// classes in _questionary_item.html.erb.
const CARD_ANSWERED = ["border-success-200/70", "bg-success-50/30", "dark:border-success-500/15", "dark:bg-success-500/5"]
const CARD_PENDING = ["border-gray-200", "bg-white", "dark:border-gray-700", "dark:bg-gray-900"]
const TITLE_ANSWERED = ["text-gray-500", "dark:text-gray-400"]
const TITLE_PENDING = ["text-gray-800", "dark:text-gray-100"]

export default class extends Controller {
  static targets = [
    "answerEditor",
    "title",
    "answeredBadge",
    "explanationEditor",
    "explanationPreview"
  ]

  // The answer field is always shown; when the item is already answered it's
  // soft-locked (pointer-events-none/dimmed). "Edit" unlocks both the answer and
  // the explanation editor in place and returns the card to its pending look
  // (no success styling / badge).
  editAnswer(event) {
    event.preventDefault()
    this.answerEditorTargets.forEach((target) => {
      target.classList.remove("pointer-events-none", "opacity-60")
      target.dataset.answerLocked = "false"
    })
    this.explanationEditorTargets.forEach((target) => target.classList.remove("pointer-events-none", "opacity-60", "hidden"))
    this.explanationPreviewTargets.forEach((target) => target.classList.add("hidden"))
    event.currentTarget.closest("div")?.classList.add("hidden")
    this.markPending()
  }

  markPending() {
    this.element.classList.remove(...CARD_ANSWERED)
    this.element.classList.add(...CARD_PENDING)
    if (this.hasTitleTarget) {
      this.titleTarget.classList.remove(...TITLE_ANSWERED)
      this.titleTarget.classList.add(...TITLE_PENDING)
    }
    this.answeredBadgeTargets.forEach((badge) => badge.classList.add("hidden"))
  }
}
